module.exports = __webpack_public_path__ + "static/img/service_2.a2465e41.png";